import { Grid, /* Box, */ IconButton, Menu, MenuItem } from "@mui/material";

import "./element.scss";
import Typography from "../../../typography/typography";
import images from "../../../../assets/images";
import React from "react";
import Button from "../../../button/button";
import AddIcon from "@mui/icons-material/Add";


interface DynamicSectionProps {
  title?: string;
  children?: React.ReactNode;
  collapsible?: boolean;
  defaultExpanded?: boolean;
}

const DynamicSectionHOC = (props: DynamicSectionProps) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleActionClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  return (
    <Grid
      className={
        props.className ? `formBuilder ${props.className}` : "formBuilder"
      }
    >
      <div className="formBuilder--Header">
        <Typography
          type="s4"
          fontWeight={"medium"}
          mb={0.5}
          color={"theme.secondary.800"}
          sx={{ cursor: "pointer", ...(!props.label?.trim() ? { fontStyle: 'italic' } : {}) }}
          onClick={props.onClick}
          data-position={props.position}
          data-name={`${props.fieldArrayName}.${props.name}`}
        >
          {props.label || "(Unnamed Section)"}
        </Typography>
        <div>
          <IconButton color="inherit" size="small" onClick={handleActionClick}>
            <img src={images.more} alt="more icon" />
          </IconButton>
          <Menu
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={() => setAnchorEl(null)}
          >
            <MenuItem
              onClick={() => {
                props.handleAccordion();
                setAnchorEl(null);
              }}
            >
              Make this section accordion
            </MenuItem>
            {!props.remove_section && (
              <MenuItem
                sx={{ color: "#F86060" }}
                onClick={() => {
                  props.removeSection();
                  setAnchorEl(null);
                }}
              >
                Remove Section
              </MenuItem>
            )}
          </Menu>
        </div>
      </div>
      <div
        className={`${
          props.activeIndex ? "formBuilder--Active" : "formBuilder--Section"
        }`}
      >
        {/* <Box sx={{ width: "100%" }} className="formBuilder--GridLayout">
          {props.children}
        </Box> */}
        <Grid container sx={{ mb: 2 }}>
          {props.children}
        </Grid>
        {!props.isFormSwitcher ? (
          <Button
            variant="outlined"
            style={{ color: "#292D32", marginBottom: "0.375rem" }}
            startIcon={<AddIcon />}
            data-position={props.position}
            data-name={`${props.fieldArrayName}.${props.name}`}
            onClick={props.handleAddButton}
          >
            Add
          </Button>
        ) : null}
      </div>
    </Grid>
  );
};
export { DynamicSectionHOC };
export default DynamicSectionHOC;
